module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Hall of Fame","subtitle":"Leaderboard and hall-of-fame for the most talented traders in the community."},"es":{"title":"Salón de la Fama","subtitle":"Exaltamos y premiamos los mejores talentos"}}')
  delete Component.options._Ctor
}
